import { MultiQuestionScreen } from "@/screens/prequal/MultiQuestionScreen"
import { BFScreen } from "@/components/standard/screen/BFScreen"
import { Horizontal, Vertical } from "@/components/standard/BFLayout"
import BFText, { H2, Small, Subtitle } from "@/components/standard/BFText"
import { ScrollView, useWindowDimensions, View } from "react-native"
import { PrimaryButton } from "@/components/buttons/CommonButtons"
import { type PreQualState, useFinishedPreQual } from "@/stores/preQual"
import { router } from "expo-router"
import Svg, { G, Path } from "react-native-svg"
import Timer from "phosphor-react-native/src/icons/Timer"
import SealCheck from "phosphor-react-native/src/icons/SealCheck"
import LinkBreak from "phosphor-react-native/src/icons/LinkBreak"

const QUESTIONS: Array<keyof PreQualState> = [
  "propertiesFlipped",
  "creditScore",
  "cashAvailable",
  "intentStatus",
]

function Logo() {
  return (
    <Svg width={87} height={30} viewBox="0 0 87 30" fill="none">
      <G clipPath="url(#clip0_4652_60318)" fill="#121F3A">
        <Path d="M23.04 7.567h2.297v4.069c.674-.904 1.902-1.273 2.99-1.273 2.8 0 4.805 2.328 4.805 4.939.017 1.122-.466 2.51-1.227 3.381-.847 1.005-2.177 1.557-3.508 1.557-1.33 0-2.489-.47-3.25-1.557v1.256H23.04V7.567zm2.16 7.618c0 1.623 1.158 2.879 2.885 2.879 1.625 0 2.748-1.188 2.748-2.746 0-1.557-1.106-2.779-2.748-2.779-1.538 0-2.886 1.105-2.886 2.645zM43.955 19.939h-2.109v-1.256c-.726.954-2.074 1.557-3.284 1.557-1.486 0-2.696-.603-3.525-1.557-.761-.887-1.193-2.092-1.193-3.381 0-1.29.345-2.361 1.226-3.332.968-1.088 2.16-1.607 3.56-1.607 1.314 0 2.455.57 3.215 1.607v-1.306h2.109v9.274zm-4.943-7.399c-1.694-.017-2.869 1.222-2.869 2.846 0 1.522 1.28 2.695 2.834 2.678 1.66.017 2.8-1.188 2.8-2.778s-1.14-2.763-2.765-2.746zM54.414 7.567h2.298v7.466l3.077-4.369h2.713l-3.457 4.537 4.027 4.737h-3.076l-3.284-4.336v4.336h-2.298V7.568zM63.992 12.89h-.812v-1.976h.812c.051-1.758 1.192-3.33 3.127-3.33l.623-.084v2.326c-.951 0-1.383.067-1.452 1.088h1.33v1.976h-1.33v7.103H63.99V12.89zM68.883 7.567h2.298V19.94h-2.298V7.567zM72.867 10.665h2.298v9.274h-2.298v-9.274zM76.766 10.665h2.108v1.205c.744-1.02 1.815-1.507 3.111-1.507 1.4 0 2.49.436 3.474 1.507.881.888 1.33 2.125 1.33 3.432 0 2.627-2.005 4.938-4.805 4.938-1.21 0-2.143-.385-2.92-1.306v4.1h-2.298V10.666zm2.16 4.637c0 .804.277 1.524.9 2.06.483.418 1.192.702 1.831.702 1.624 0 2.834-1.222 2.834-2.778a2.75 2.75 0 00-2.748-2.746c-1.555 0-2.817 1.222-2.817 2.762zM51.899 17.192c-1.055.897-2.68.855-3.681-.115a2.555 2.555 0 010-3.69c1.014-.983 2.65-1.015 3.706-.094l1.677-1.625a5.14 5.14 0 00-3.478-1.336c-1.252 0-2.594.477-3.58 1.433a4.802 4.802 0 000 6.935c1.925 1.866 5.054 1.909 7.034.117L51.9 17.192h-.001zM73.93 9.998c.712 0 1.29-.56 1.29-1.249 0-.69-.578-1.249-1.29-1.249-.712 0-1.29.56-1.29 1.249 0 .69.578 1.249 1.29 1.249z" />
      </G>
      <G clipPath="url(#clip1_4652_60318)">
        <Path
          d="M9.11 12.541c1.912-.004 3.285 1.394 3.27 3.33-.014 1.904-1.461 3.362-3.312 3.336-1.765-.025-3.232-1.526-3.248-3.323-.016-1.891 1.41-3.34 3.29-3.343z"
          fill="#121F3A"
        />
        <Path d="M4.914 0H.008v14.402h4.906V0z" fill="#75FAD4" />
        <Path
          d="M14.454 8.617c-4.091-3-9.614-2.127-12.637 1.811-.703.915-1.43 2.098-1.817 3.977h4.912c.045-.131.11-.27.167-.395.076-.18.15-.32.233-.45A4.403 4.403 0 019.1 11.385c1.989 0 3.67 1.334 4.225 3.17.285.903.228 1.882-.072 2.86a5.156 5.156 0 01-.64 1.218c-.52.736-1.355 1.974-2.117 3.116L6.66 27.275 10.582 30l4.621-6.66c.449-.633.898-1.267 1.345-1.902 2.902-4.118 1.893-9.898-2.094-12.821z"
          fill="#121F3A"
        />
      </G>
    </Svg>
  )
}

export default function PreQualNew() {
  const isDone = useFinishedPreQual(QUESTIONS)
  const { width } = useWindowDimensions()

  return (
    <BFScreen gradientBackground={true} dark={true} noBackButton={true}>
      <Horizontal className="p-2 bg-teal justify-center items-center mb-5">
        <Horizontal className={"gap-1 justify-center items-center"}>
          <Timer size={12} />
          <Small color={"primary"}>3 min | </Small>
          <SealCheck size={12} />
          <Small color={"primary"}>No credit impact | </Small>
          <LinkBreak size={12} />
          <Small color={"primary"}>Non-binding</Small>
        </Horizontal>
      </Horizontal>
      <Vertical
        className={"rounded-t-3xl bg-off-white flex-1 max-w-[550px] mx-auto"}
      >
        <H2 color={"primary"} className={"p-5 mt-3"}>
          Let&apos;s get you <BFText color={"primaryLight"}>funded</BFText>
        </H2>
        <Subtitle color={"primary"} className={"px-5"}>
          Answer a few short questions so we can create the best quote for your
          next deal from Backflip.
        </Subtitle>
        <ScrollView className="flex-1 p-5">
          <MultiQuestionScreen questions={QUESTIONS} />
        </ScrollView>
        <View
          className={
            "bg-white p-5 justify-between w-full flex flex-row border-t border-light-grey"
          }
        >
          <View className={"flex-1 justify-start flex-row shrink"}>
            {width > 350 && <Logo />}
          </View>
          <PrimaryButton
            onPress={() => {
              router.push("/loans")
            }}
            disabled={!isDone}
            className={"w-[200px]"}
            size={"sm"}
            title={"Next: See Loan Options"}
            testID={"next-loan-options"}
          />
        </View>
      </Vertical>
    </BFScreen>
  )
}
